import { FC } from "react";
import styled from "styled-components";
import { LogeWithOffers } from "~/applications/OfferSearch/Domain/LogeWithOffers";
import { PinPointKing } from "~/components/Map/PinPoint";
import MediaCarousel from "~/components/MediaCarousel";
import StayRequest from "~/core/StayRequest";
import mediaQueries from "~/guidelines/Theme/mediaQueries";
import HotelRoomList from "./HotelRoomList";

interface HotelCardProps {
  hotel: LogeWithOffers;
  destinationSeoSlug: string;
  selectedStayRequest: StayRequest;
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(6)};
  margin-bottom: ${({ theme }) => theme.spacing(8)};
  width: 100%;
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;

  ${mediaQueries.xl()} {
    flex-direction: row;
  }
`;

const MediaCarouselWrapper = styled.div`
  width: 100%;

  ${mediaQueries.xl()} {
    width: 60%;
  }
`;

const HotelCard: FC<HotelCardProps> = ({
  hotel,
  destinationSeoSlug,
  selectedStayRequest,
}) => {
  const gallery =
    hotel.offers.length > 0
      ? hotel.offers[0].unitGroup.images.map((img) => ({
          asset: {
            url: img.asset.url,
          },
          caption: img.caption
            ? {
                _type: "caption",
                en: img.caption,
                fr: img.caption,
              }
            : null,
        }))
      : [];

  const mapData = {
    latitude: hotel.address.coordinate.latitude,
    longitude: hotel.address.coordinate.longitude,
    zoom: 15,
    marker: {
      label: hotel.name,
      longitude: hotel.address.coordinate.longitude,
      latitude: hotel.address.coordinate.latitude,
      kind: PinPointKing.PinkPin,
      zoom: 15,
    },
  };

  return (
    <Container>
      <ContentWrapper>
        <MediaCarouselWrapper>
          <MediaCarousel
            gallery={gallery}
            mapData={mapData}
            mobileHeight="300px"
            customBorderRadius={{
              desktop: {
                topRight: "0",
                bottomRight: "0",
              },
              mobile: {
                bottomLeft: "0",
                bottomRight: "0",
              },
            }}
          />
        </MediaCarouselWrapper>

        <HotelRoomList
          hotel={hotel}
          selectedStayRequest={selectedStayRequest}
          destinationSlug={destinationSeoSlug}
        />
      </ContentWrapper>
    </Container>
  );
};

export default HotelCard;
